const propertyArrayConverter = {
    fromAttribute: (value) => {
        try {
            if (value) {
                value = JSON.parse(value);
            }

            if (!Array.isArray(value)) {
                value = Object.values(value);
            }

            return value ? value : [];
        } catch (e) {
            console.error('Failed to parse items:', e);
            return [];
        }
    },
    toAttribute: (value) => JSON.stringify(value),
};

export default propertyArrayConverter;
